import _ from 'lodash'

import Row from '../../../../common/components/Form/Row.js'
import BaseReconcileForm from '../BaseReconcileForm.js'
import ReconcileSelect from '../ReconcileSelect.js'

export default function ReconcileForm(props) {
  if (_.isEmpty(props.columnsToDataMap)) {
    return null
  }

  return (
    <BaseReconcileForm className="medium-10" {...props}>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.reference_id}
          errorMessage={props.columnErrors.reference_id}
          name="reference_id"
          label="Reference ID"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.warehouse}
          errorMessage={props.columnErrors.warehouse}
          name="warehouse"
          label="Warehouse"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.internal_notes}
          errorMessage={props.columnErrors.internal_notes}
          name="internal_notes"
          label="Internal Notes"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.manufacturer_notes}
          errorMessage={props.columnErrors.manufacturer_notes}
          name="manufacturer_notes"
          label="Manufacturer Notes"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.shipping_amount}
          errorMessage={props.columnErrors.shipping_amount}
          name="shipping_amount"
          label="Shipping Cost"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.tax_amount}
          errorMessage={props.columnErrors.tax_amount}
          name="tax_amount"
          label="Tax Cost"
          className="medium-10"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <div className="medium-12 columns">
          <hr />
          <h5>Order Contents</h5>
        </div>
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_sku}
          errorMessage={props.columnErrors.line_sku}
          name="line_sku"
          label="SKU"
          className="medium-5"
          onChange={props.updateColumnMapping}
        />
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_requested_quantity}
          errorMessage={props.columnErrors.line_requested_quantity}
          name="line_requested_quantity"
          label="Requested Quantity"
          className="medium-7 end"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_unit_cost}
          errorMessage={props.columnErrors.line_unit_cost}
          name="line_unit_cost"
          label="Unit Cost"
          className="medium-5"
          onChange={props.updateColumnMapping}
        />
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_labor_unit_cost}
          errorMessage={props.columnErrors.line_labor_unit_cost}
          name="line_labor_unit_cost"
          label="Labor Unit Cost"
          className="medium-7 end"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_internal_notes}
          errorMessage={props.columnErrors.line_internal_notes}
          name="line_internal_notes"
          label="Line Internal Notes"
          className="medium-5"
          onChange={props.updateColumnMapping}
        />
        <ReconcileSelect
          columns={props.columns}
          value={props.columnsToDataMap.line_manufacturer_notes}
          errorMessage={props.columnErrors.line_manufacturer_notes}
          name="line_manufacturer_notes"
          label="Line Manufacturer Notes"
          className="medium-7 end"
          onChange={props.updateColumnMapping}
        />
      </Row>
      <Row>
        <div className="medium-12 columns">
          <hr />
        </div>
      </Row>
    </BaseReconcileForm>
  )
}
